export default {
      id: "color_wgs_hh-usage",
      viewBox: "0 0 95 115",
      url: __webpack_public_path__ + "sprite.svg#color_wgs_hh",
      toString: function () {
        return this.url;
      }
    }